import { administratorRoles } from "../config/roles";
import { ListDefinition } from "./listDefinition.types";

const recordRoute = "/competition-stage";

/**
 * The competition stages list. Paged by the search endpoint, which is the only read the
 * warehouse offers - `GetAllEntityDetailedInfo` is a ticketing route. It reads on
 * arrival, as the legacy table did, rather than waiting for a search.
 *
 * The warehouse table has no state column, so there is no active/inactive to filter by.
 */
export const competitionStagesListDefinition: ListDefinition = {
  path: "/competition-stages",
  entityName: "dwcompetitionstage",
  recordRoute,
  title: "Competition Stages",
  allowedRoles: administratorRoles,
  data: "search-paged",
  searchOnLoad: true,
  // Lower case: the repository reads this key from a case-sensitive dictionary.
  filters: [{ name: "name", label: "Name", kind: "text", width: "wide" }],
  filterByStatus: false,
  allowAdd: true,
  addRoles: administratorRoles,
  allowStatusEdit: false,
  allowDelete: true,
  deleteRoles: administratorRoles,
  columns: [
    {
      key: "Name",
      label: "Name",
      width: 300,
      sortable: true,
      link: { to: recordRoute, idKey: "Id", newTab: "button" },
    },
    {
      key: "createdon",
      label: "Created On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "modifiedon",
      label: "Modified On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
  ],
};
